var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHumidity = function SvgHumidity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.2 2.388c.3-.5 1.2-.5 1.6 0 .7.9 6 8.6 5.9 12.3 0 4-3 7.3-6.7 7.3s-6.7-3.3-6.7-7.3c0-3.532 4.829-10.71 5.79-12.137zm-3.9 12.3c0 2.9 2.1 5.3 4.7 5.3s4.8-2.4 4.7-5.3c0-2.2-2.9-7.1-4.7-9.9-1.8 2.8-4.7 7.7-4.7 9.9m5.6 3.8q-.6 0-.9-.6c-.2-.5.1-1.1.5-1.4.4-.2.7-.5.8-.8s.1-.7 0-1.1c-.2-.5.1-1.1.6-1.3s1.1.1 1.3.6c.4.8.4 1.8 0 2.6-.4.9-1 1.6-1.9 1.9-.1.1-.3.1-.4.1",
    clipRule: "evenodd"
  })));
};
export default SvgHumidity;